module.exports = __webpack_public_path__ + "img/blueBar.524fa2ec.png";